import { AnyAction } from 'redux';
import { AxiosPromise, AxiosResponse } from 'axios';
import { ThunkAction } from 'redux-thunk';
import { ServerResponse } from 'data/types';
import { RootState } from 'data/root.reducers';

export const API_PATH_XTPS = '/xtps';
export const API_PATH_XTP_OPTIONS = '/lboptions';

export const GET_XTPS = 'GET_XTPS';
export const GET_XTPS_PENDING = 'GET_XTPS_PENDING';
export const GET_XTPS_FULFILLED = 'GET_XTPS_FULFILLED';
export const GET_XTPS_REJECTED = 'GET_XTPS_REJECTED';

export const GET_XTP = 'GET_XTP';
export const GET_XTP_PENDING = 'GET_XTP_PENDING';
export const GET_XTP_FULFILLED = 'GET_XTP_FULFILLED';
export const GET_XTP_REJECTED = 'GET_XTP_REJECTED';

export const CREATE_XTP = 'CREATE_XTP';
export const CREATE_XTP_PENDING = 'CREATE_XTP_PENDING';
export const CREATE_XTP_FULFILLED = 'CREATE_XTP_FULFILLED';
export const CREATE_XTP_REJECTED = 'CREATE_XTP_REJECTED';

export const UPDATE_XTP = 'UPDATE_XTP';
export const UPDATE_XTP_PENDING = 'UPDATE_XTP_PENDING';
export const UPDATE_XTP_FULFILLED = 'UPDATE_XTP_FULFILLED';
export const UPDATE_XTP_REJECTED = 'UPDATE_XTP_REJECTED';

export const DELETE_XTP = 'DELETE_XTP';
export const DELETE_XTP_PENDING = 'DELETE_XTP_PENDING';
export const DELETE_XTP_FULFILLED = 'DELETE_XTP_FULFILLED';
export const DELETE_XTP_REJECTED = 'DELETE_XTP_REJECTED';

export const GET_XTP_OPTIONS = 'GET_XTP_OPTIONS';
export const GET_XTP_OPTIONS_PENDING = 'GET_XTP_OPTIONS_PENDING';
export const GET_XTP_OPTIONS_FULFILLED = 'GET_XTP_OPTIONS_FULFILLED';
export const GET_XTP_OPTIONS_REJECTED = 'GET_XTP_OPTIONS_REJECTED';

export const UPDATE_XTP_OPTIONS = 'UPDATE_XTP_OPTIONS';
export const UPDATE_XTP_OPTIONS_PENDING = 'UPDATE_XTP_OPTIONS_PENDING';
export const UPDATE_XTP_OPTIONS_FULFILLED = 'UPDATE_XTP_OPTIONS_FULFILLED';
export const UPDATE_XTP_OPTIONS_REJECTED = 'UPDATE_XTP_OPTIONS_REJECTED';

export const XTP_LOADING = 'XTP_LOADING';
export const GO_TO_XTP_CREATE = 'GO_TO_XTP_CREATE';
export const GO_TO_XTP_EDIT = 'GO_TO_XTP_EDIT';
export const GO_TO_XTP_VIEW = 'GO_TO_XTP_VIEW';
export const UPDATE_ERRORS = 'UPDATE_ERRORS';

export interface Xtp {
  id: string
  lbId: string
  ipAddr: string
  owner?: string
  access?: string
  group?: string
}

export const newXtp: Xtp = {
  id: '',
  lbId: '',
  ipAddr: '',
};

export interface XtpSerialized {
  ACCESS: string
  GROUP: string
  IPADDR: string
  LBID: string
  OWNER: string
  id: string
}

export const newXtpOptions: XtpOptions = {
  id: '',
  ID: '',
  rdrHeartBeatSecs: '1',
  rdrhBtoClose: '1',
  wtrHeartBeatSecs: '1',
  wtrReconnectSecs: '1',
  smpReportInterval: '1',
  droppedAlmInterval: '1',
  throttleUpdInterval: '1',
  dbSyncWaitTime: '1',
  dbQueryTimeout: '1',
  dbQueryIntvl: '1',
  bwAlmThreshHigh: '50',
  bwAlmThreshLow: '50',
  scdRouteAlgorithm: 'AUTOCONF',
};
export interface XtpOptions {
  id: string
  ID: string
  rdrHeartBeatSecs: string
  rdrhBtoClose: string
  wtrHeartBeatSecs: string
  wtrReconnectSecs: string
  smpReportInterval: string
  droppedAlmInterval: string
  throttleUpdInterval: string
  dbSyncWaitTime: string
  dbQueryTimeout: string
  dbQueryIntvl: string
  bwAlmThreshHigh: string
  bwAlmThreshLow: string
  scdRouteAlgorithm: string
}

export interface XtpOptionsSerialized {
  ACCESS: string
  BWALMTHRESHHIGH: string
  BWALMTHRESHLOW: string
  DBQUERYINTVL: string
  DBQUERYTIMEOUT: string
  DBSYNCWAITTIME: string
  DROPPEDALMINTERVAL: string
  GROUP: string
  ID: string
  OWNER: string
  RDRHBTOCLOSE: string
  RDRHEARTBEATSECS: string
  SCDROUTEALGORITHM: string
  SMPREPORTINTERVAL: string
  THROTTLEUPDINTERVAL: string
  WTRHEARTBEATSECS: string
  WTRRECONNECTSECS: string
  id: string
}

export interface XtpFormData {
  main: Xtp
  xtpOptions: XtpOptions
}

export interface XtpUiState {
  isLoading: boolean,
  wasXtpUpdatedWithErrors: boolean,
}
export interface XtpState {
  entities: Xtp[],
  xtpOptions: XtpOptions[],
  errors: { xtp: string, xtpOptions: string },
  ui: XtpUiState
}

export interface GetXtpAction extends AnyAction {
  type: typeof GET_XTPS
  payload: AxiosPromise<ServerResponse<Xtp>>
}

export interface GetXtpPendingAction extends AnyAction {
  type: typeof GET_XTPS_PENDING
  payload: AxiosResponse<ServerResponse<Xtp>>
}
export interface GetXtpFulfilledAction extends AnyAction {
  type: typeof GET_XTPS_FULFILLED
  payload: AxiosResponse<ServerResponse<Xtp>>
}

export interface GetXtpRejectedAction extends AnyAction {
  type: typeof GET_XTPS_REJECTED
  payload: AxiosResponse<ServerResponse<Xtp>>
}

export interface GetXtpByIdAction extends AnyAction {
  type: typeof GET_XTP
  payload: AxiosPromise<ServerResponse<Xtp>>
}

export interface GetXtpByIdPendingAction extends AnyAction {
  type: typeof GET_XTP_PENDING
  payload: AxiosResponse<ServerResponse<Xtp>>
}
export interface GetXtpByIdFulfilledAction extends AnyAction {
  type: typeof GET_XTP_FULFILLED
  payload: AxiosResponse<ServerResponse<Xtp>>
}

export interface GetXtpByIdRejectedAction extends AnyAction {
  type: typeof GET_XTP_REJECTED
  payload: AxiosResponse<ServerResponse<Xtp>>
}

export interface CreateXtpThunkAction extends ThunkAction<void, RootState, void, AnyAction> {}

export interface CreateXtpAction extends AnyAction {
  type: typeof CREATE_XTP
  payload: AxiosPromise<ServerResponse<Xtp>>
}

export interface CreateXtpPendingAction extends AnyAction {
  type: typeof CREATE_XTP_PENDING
  payload: AxiosResponse<ServerResponse<Xtp>>
}
export interface CreateXtpFulfilledAction extends AnyAction {
  type: typeof CREATE_XTP_FULFILLED
  payload: AxiosResponse<ServerResponse<Xtp>>
}

export interface CreateXtpRejectedAction extends AnyAction {
  type: typeof CREATE_XTP_REJECTED
  payload: AxiosResponse<ServerResponse<Xtp>>
}

export interface UpdateXtpThunkAction extends ThunkAction<void, RootState, void, AnyAction> {}

export interface UpdateXtpAction extends AnyAction {
  type: typeof UPDATE_XTP
  payload: AxiosPromise<ServerResponse<Xtp>>
}

export interface UpdateXtpPendingAction extends AnyAction {
  type: typeof UPDATE_XTP_PENDING
  payload: AxiosResponse<ServerResponse<Xtp>>
}
export interface UpdateXtpFulfilledAction extends AnyAction {
  type: typeof UPDATE_XTP_FULFILLED
  payload: AxiosResponse<ServerResponse<Xtp>>
}

export interface UpdateXtpRejectedAction extends AnyAction {
  type: typeof UPDATE_XTP_REJECTED
  payload: AxiosResponse<ServerResponse<Xtp>>
}

export interface DeleteXtpThunkAction extends ThunkAction<void, RootState, void, AnyAction> {}

export interface DeleteXtpAction extends AnyAction {
  type: typeof DELETE_XTP
  payload: AxiosPromise<ServerResponse<Xtp>>
}

export interface DeleteXtpPendingAction extends AnyAction {
  type: typeof DELETE_XTP_PENDING
  payload: AxiosResponse<ServerResponse<Xtp>>
}
export interface DeleteXtpFulfilledAction extends AnyAction {
  type: typeof DELETE_XTP_FULFILLED
  payload: AxiosResponse<ServerResponse<Xtp>>
}

export interface DeleteXtpRejectedAction extends AnyAction {
  type: typeof DELETE_XTP_REJECTED
  payload: AxiosResponse<ServerResponse<Xtp>>
}

export interface UpdateErrors extends AnyAction {
  type: typeof UPDATE_ERRORS
  payload: { xtp: string, xtpOptions: string }
}

export interface GetXtpOptionsAction extends AnyAction {
  type: typeof GET_XTP_OPTIONS
  payload: AxiosPromise<ServerResponse<XtpOptions>>
}

export interface GetXtpOptionsPendingAction extends AnyAction {
  type: typeof GET_XTP_OPTIONS_PENDING
  payload: AxiosResponse<ServerResponse<XtpOptions>>
}
export interface GetXtpOptionsFulfilledAction extends AnyAction {
  type: typeof GET_XTP_OPTIONS_FULFILLED
  payload: AxiosResponse<ServerResponse<XtpOptions>>
}

export interface GetXtpOptionsRejectedAction extends AnyAction {
  type: typeof GET_XTP_OPTIONS_REJECTED
  payload: AxiosResponse<ServerResponse<XtpOptions>>
}

export interface UpdateXtpXdpConnectionThunkAction extends ThunkAction<void, RootState, void, AnyAction> {}

export interface UpdateXtpOptionsAction extends AnyAction {
  type: typeof UPDATE_XTP_OPTIONS
  payload: AxiosPromise<ServerResponse<XtpOptions>>
}

export interface UpdateXtpOptionsPendingAction extends AnyAction {
  type: typeof UPDATE_XTP_OPTIONS_PENDING
  payload: AxiosResponse<ServerResponse<XtpOptions>>
}
export interface UpdateXtpOptionsFulfilledAction extends AnyAction {
  type: typeof UPDATE_XTP_OPTIONS_FULFILLED
  payload: AxiosResponse<ServerResponse<XtpOptions>>
}

export interface UpdateXtpOptionsRejectedAction extends AnyAction {
  type: typeof UPDATE_XTP_OPTIONS_REJECTED
  payload: AxiosResponse<ServerResponse<XtpOptions>>
}

export type XtpActionTypes =
  GetXtpAction |
  GetXtpPendingAction |
  GetXtpFulfilledAction |
  GetXtpRejectedAction |
  GetXtpByIdAction |
  GetXtpByIdPendingAction |
  GetXtpByIdFulfilledAction |
  GetXtpByIdRejectedAction |
  CreateXtpAction |
  CreateXtpPendingAction |
  CreateXtpFulfilledAction |
  CreateXtpRejectedAction |
  UpdateXtpAction |
  UpdateXtpPendingAction |
  UpdateXtpFulfilledAction |
  UpdateXtpRejectedAction |
  DeleteXtpAction |
  DeleteXtpPendingAction |
  DeleteXtpFulfilledAction |
  DeleteXtpRejectedAction |
  UpdateErrors |
  GetXtpOptionsAction |
  GetXtpOptionsPendingAction |
  GetXtpOptionsFulfilledAction |
  GetXtpOptionsRejectedAction |
  UpdateXtpOptionsAction |
  UpdateXtpOptionsPendingAction |
  UpdateXtpOptionsFulfilledAction |
  UpdateXtpOptionsRejectedAction;
